import React from 'react'
import styled from 'styled-components'
import ApiSettings from './config/ApiSettings'
import Web3Settings from './config/Web3Settings'
import TokenRegistry from './config/TokenRegistry'
import Notifications from './config/Notifications'
import RelayerExecutorForm from './config/RelayerExecutorForm'
import { PriceOracleSettings } from './config/PriceOracle'

export default function Config() {
  return (
    <Wrap>
      <Section>
        <SectionLabel>Relayer Executor</SectionLabel>
        <RelayerExecutorForm />
      </Section>
      <Section>
        <SectionLabel>Web3</SectionLabel>
        <Web3Settings />
      </Section>
      <Section>
        <SectionLabel>Price Oracle</SectionLabel>
        <PriceOracleSettings />
      </Section>
      <Section>
        <SectionLabel>Token Registry</SectionLabel>
        <TokenRegistry />
      </Section>
      <Section>
        <SectionLabel>Notifications</SectionLabel>
        <Notifications />
      </Section>
      <Section>
        <SectionLabel>API</SectionLabel>
        <ApiSettings />
      </Section>
    </Wrap>
  )
}

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const SectionLabel = styled.h2`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: #777;
  margin: 0;
`
